import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "ic-pessoas_48c8fec4d99fc01ecc2a3a936c469740",
  "use": "ic-pessoas_48c8fec4d99fc01ecc2a3a936c469740-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"ic-pessoas_48c8fec4d99fc01ecc2a3a936c469740\">\n    <path fill-rule=\"nonzero\" d=\"M20 15a3 3 0 1 0-3-3 2.987 2.987 0 0 0 3 3zm-8 0a3 3 0 1 0-3-3 2.987 2.987 0 0 0 3 3zm0 2c-2.33 0-7 1.17-7 3.5V23h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05A4.22 4.22 0 0 1 21 20.5V23h6v-2.5c0-2.33-4.67-3.5-7-3.5z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id